import { addDays, date2str, str2date } from '@/utils/format';

export const calculateUntil = (periodUntil, effectivePeriodUntil, toTimeStr) => {
    if (effectivePeriodUntil) {
        return effectivePeriodUntil;
    }

    if (!periodUntil) {
        const time = str2date(toTimeStr);
        return date2str(addDays(time, -1));
    }
    const periodUntilTime = str2date(periodUntil);
    const toTime = str2date(toTimeStr);
    const result = toTime.getTime() < periodUntilTime.getTime() ? toTime : periodUntilTime;
    // effectivePeriodUntil is calculated by actual slots it has same date of the latest slot
    // periodUntil and toTime is one date ahead of the latest slot and it will not return the slots on periodUntil/toTime date
    // minus one day to not count the periodUntil to dateWithData
    return date2str(addDays(result, -1));
};
